import { useCallback, useState } from 'react';

interface RecipeFormFeedbackState {
  message: string;
  isError: boolean;
}

interface UseRecipeFormFeedbackResult extends RecipeFormFeedbackState {
  resetFeedback: () => void;
  setFeedback: (message: string, isError?: boolean) => void;
  setMessage: (message: string) => void;
  setIsError: (isError: boolean) => void;
}

export const useRecipeFormFeedback = (): UseRecipeFormFeedbackResult => {
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const resetFeedback = useCallback(() => {
    setMessage('');
    setIsError(false);
  }, []);

  const setFeedback = useCallback((nextMessage: string, nextIsError: boolean = false) => {
    setMessage(nextMessage);
    setIsError(nextIsError);
  }, []);

  return {
    message,
    isError,
    resetFeedback,
    setFeedback,
    setMessage,
    setIsError,
  };
};

export default useRecipeFormFeedback;
